import { SVGProps } from 'react';

const MountainSnow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.14 15.08q3.93-2.355 7.86.42c2.74 1.94 5.49 2 8.23.19M8 3l4 8 5-5 5 15H2z"
    />
  </svg>
);
export default MountainSnow;
